import { useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { useQuery } from '@tanstack/react-query'
import { apiService, User } from '@/lib/api'
import DashboardLayout from '@/components/DashboardLayout'
import UploadSection from '@/components/UploadSection'
import { Alert } from 'antd'

export default function Dashboard() {
  const navigate = useNavigate()
  const [user, setUser] = useState<User | null>(null)

  useEffect(() => {
    const storedUser = localStorage.getItem('user')
    if (storedUser) {
      setUser(JSON.parse(storedUser))
    }
  }, [])

  const { data: dashboardData, isLoading: dashboardLoading, error: dashboardError } = useQuery({
    queryKey: ['dashboard-summary'],
    queryFn: () => apiService.getDashboardSummary(),
    enabled: !!user,
  })

  const { data: profileData, isLoading: profileLoading } = useQuery({
    queryKey: ['profile'],
    queryFn: () => apiService.getProfile(),
    enabled: !!user,
  })

  useEffect(() => {
    if (profileData?.success && profileData.user) {
      const userData = {
        ...profileData.user,
        needs_onboarding: profileData.needs_onboarding
      }
      localStorage.setItem('user', JSON.stringify(userData))
      setUser(userData)

      if (profileData.needs_onboarding) {
        navigate('/onboarding')
      }
    }
  }, [profileData, navigate])

  const handleLogout = () => {
    localStorage.removeItem('authToken')
    localStorage.removeItem('user')
    navigate('/')
  }

  return (
    <DashboardLayout user={user} onLogout={handleLogout}>
      <div className="max-w-6xl mx-auto space-y-6 sm:space-y-10">
        <div className="space-y-1">
          <h1 className="text-2xl sm:text-3xl md:text-4xl font-bold text-white">
            Welcome back, <span className="text-transparent bg-clip-text bg-gradient-to-r from-cyan-400 to-indigo-400">{user?.first_name}</span>
          </h1>
          <p className="text-slate-400 text-sm sm:text-base">Manage your accounting documents and create new invoices</p>
        </div>

        <UploadSection />

        {dashboardError && (
          <Alert
            message="API Connection Status"
            description="Unable to connect to the Rails API. Please ensure the backend is running."
            type="warning"
            showIcon
            style={{
              borderRadius: 12,
              background: 'rgba(251, 191, 36, 0.1)',
              border: '1px solid rgba(251, 191, 36, 0.2)',
              color: '#fbbf24'
            }}
          />
        )}
      </div>
    </DashboardLayout>
  )
}
